import { Text } from '@avanta/shared/components/Text';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { t } from '@avanta/shared/i18n';
import { CircleCheck } from 'lucide-react';

export const EmptyNotificationsState = (): React.ReactElement => (
  <div className="bg-gray-100 flex w-full items-center gap-3 rounded-3xl py-6 pr-6 pl-7">
    <CircleCheck className="text-teal-600 size-10 shrink-0" strokeWidth={1.5} aria-hidden />
    <div className="flex min-w-0 flex-col">
      <Text tag="p" variant="text-sm-medium" className="text-denim-500 leading-4.5">
        {t('NotificationsPage.empty.title', { ns: LOCIZE_NS.INSURANCE })}
      </Text>
      <Text variant="text-sm-regular" className="text-gray-500 leading-4.5">
        {t('NotificationsPage.empty.description', { ns: LOCIZE_NS.INSURANCE })}
      </Text>
    </div>
  </div>
);
